// src/lib/landing-mode.ts
// Which landing page `/` serves (three modes). Flip LANDING_MODE and follow
// docs/landing-modes.md (the page's <title>, meta tags, manifest and link-preview
// image live outside React).
//
//   'showcase'      the "Lightbox" lava showcase, a top-level route outside PublicLayout (default, since 2026-10-20)
//   'it-solutions'  the simple IT-solutions contact page (safe fallback)
//   'builder'       the original "Describe it. We build it." AI website builder page (parked)

export type LandingMode = 'it-solutions' | 'builder' | 'showcase'

export const LANDING_MODE: LandingMode = 'showcase'
